/* eslint-disable react-hooks/exhaustive-deps */

import { MotionLazy } from 'src/components/animate/motion-lazy';
import ProgressBar from 'src/components/progress-bar';
import { SettingsProvider } from 'src/components/settings';
import 'src/global.css';
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import 'src/locales/i18n';
import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';

import { SearchProvider } from './components/app-header/app-header-search';
import DeploymentUpdateBoundary from './components/deployment-update-boundary';
import { SnackbarProvider } from './components/snackbar';
import { AxiosClientProvider } from './http/context/axios-client-context';
import { LocalizationProvider } from './locales';

export default function App() {
  useScrollToTop();

  return (
    <LocalizationProvider>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'light', // 'light' | 'dark'
          themeDirection: 'ltr', //  'rtl' | 'ltr'
          themeContrast: 'default', // 'default' | 'bold'
          themeLayout: 'horizontal', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: false,
        }}
      >
        <ThemeProvider>
          <MotionLazy>
            <SnackbarProvider>
              <ProgressBar />
              <SearchProvider>
                <AxiosClientProvider>
                  <DeploymentUpdateBoundary>
                    <Router />
                  </DeploymentUpdateBoundary>
                </AxiosClientProvider>
              </SearchProvider>
            </SnackbarProvider>
          </MotionLazy>
        </ThemeProvider>
      </SettingsProvider>
    </LocalizationProvider>
  );
}
